(function () {
  function initSection(root) {
    var oneOpen = root.getAttribute('data-one-open') === 'true';

    root.querySelectorAll('[data-custom-faq-item]').forEach(function (item) {
      var btn = item.querySelector('.custom-faq__summary');
      var panel = item.querySelector('.custom-faq__panel');
      if (!btn || !panel) return;

      function setOpen(open) {
        if (open) {
          item.classList.add('is-open');
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('inert');
        } else {
          item.classList.remove('is-open');
          panel.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('inert', '');
        }
      }

      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');

        if (oneOpen && willOpen) {
          root.querySelectorAll('[data-custom-faq-item]').forEach(function (other) {
            if (other === item) return;
            var op = other.querySelector('.custom-faq__panel');
            var ob = other.querySelector('.custom-faq__summary');
            if (op && op.classList.contains('is-open')) {
              other.classList.remove('is-open');
              op.classList.remove('is-open');
              op.setAttribute('inert', '');
              if (ob) ob.setAttribute('aria-expanded', 'false');
            }
          });
        }

        setOpen(willOpen);
      });
    });
  }

  document.querySelectorAll('[data-custom-faq]').forEach(initSection);
})();
